import type { Locale } from "antd/es/locale";
import arEG from "antd/locale/ar_EG";

/**
 * Antd's built-in `ar_EG` DatePicker locale sets `shortWeekDays` to the FULL
 * weekday names ("الأحد", "الإثنين", "الثلاثاء", ...) instead of an
 * abbreviated form the way every other locale does (English: "Su", "Mo",
 * "Tu", ...). In the calendar's 7-column grid the full names don't fit and
 * visibly run into each other. Swap in the standard 3-letter Arabic
 * abbreviations (the same ones dayjs' `ar` locale uses for `weekdaysShort`)
 * so the header lines up like every other locale.
 */
const ARABIC_SHORT_WEEKDAYS = ["أحد", "إثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"];

/** Shared `antd/locale/ar_EG`, patched so the calendar weekday header fits. */
export const arabicCalendarLocale: Locale = {
  ...arEG,
  DatePicker: arEG.DatePicker && {
    ...arEG.DatePicker,
    lang: {
      ...arEG.DatePicker.lang,
      shortWeekDays: ARABIC_SHORT_WEEKDAYS,
    },
  },
};
